import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useOrderConversionFilterFields } from './hooks/useOrderConversionFilterFields';

export const OrderConversionListFilterChips: React.FC = () => {
  const fields = useOrderConversionFilterFields();

  return <FilterChips fields={fields} />;
};
